import { render, staticRenderFns } from "./Registeration.vue?vue&type=template&id=412ae116"
import script from "./Registeration.vue?vue&type=script&lang=js"
export * from "./Registeration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports